export const NAME = 'dashboard-marketPlace';

export const toggleButtonGroupValues = {
	TAKEN: 'TAKEN',
	DRAFT: 'DRAFT',
};
